import { render, staticRenderFns } from "./CategoriaProdutoUpdate.vue?vue&type=template&id=621b354a"
import script from "./CategoriaProdutoUpdate.vue?vue&type=script&lang=js"
export * from "./CategoriaProdutoUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports